import { GriddleStyleConfig } from 'griddle-react';
import * as React from 'react';

export const gridStyle: GriddleStyleConfig = {
    classNames: {
        Table: 'table table-striped',
        Filter: 'form-control',
        PageDropdown: 'form-control',
        PreviousButton: 'btn btn-primary prev-button',
        NextButton: 'btn btn-primary next-button'
    }
};

export const gridSimpleLayout = ({ Table, Pagination, Filter, SettingsWrapper }: any) => (
    <div className="datagrid">
        <Table />
        <form className="form-inline">
            <div className="datagrid-controls-bottom">
                <Pagination />
            </div>
        </form>
    </div>
);


// WEBPACK FOOTER //
// ./src/config/grid-config-simple.tsx